import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, SupportedLocale, SUPPORTED_LOCALES, LocalizationContent } from './types'


type LocaleConfig = Record<SupportedLocale, LocalizationContent>

export const setupLocalization = async (
  locales: Readonly<LocaleConfig>,
): Promise<void> => {
  if (i18n.isInitialized) {
    return
  }
  await i18n.use(initReactI18next).init(geti18nConfig(locales))
}

function geti18nConfig(locales: Readonly<LocaleConfig>): InitOptions {
  return {
    resources: SUPPORTED_LOCALES.reduce(
      (languages, lang) => ({
        ...languages,
        [lang]: {
          translation: locales[lang],
        },
      }),
      {},
    ),
    lng: DEFAULT_LOCALE, // if you're using a language detector, do not define the lng option
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
  }
}
